import React, { Suspense, useEffect, useContext } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from 'app/templates/sidebar';
import useWindowDimensions from 'shared/hooks/useWindowDimensions';
import { Loading } from 'shared/ui/loading';
import { GlobalStateContext } from 'app/providers/GlobalStateProvider';

const DashboardTemplate = () => {
  const { smallSide, setSmallSide } = useContext(GlobalStateContext);
  // const [openModalAccessMenu, setOpenModalAccessMenu] = useState(false);
  const { isMobile } = useWindowDimensions();
  const location = useLocation();

  useEffect(() => {
    if (isMobile) setSmallSide(true);
  }, [isMobile, location]);

  // The dashboard is a fixed-viewport shell: the sidebar and the page area each
  // own their scroll, so the document itself must never scroll. Without this,
  // some pages let body grow past 100vh and the user can scroll into an empty
  // <body>-background gap. Locked only while the dashboard is mounted so
  // non-dashboard routes (login, etc.) keep their normal document scroll.
  // Skipped on mobile: pages stack vertically past the viewport and rely on the
  // document itself scrolling, so locking body overflow would trap the content.
  useEffect(() => {
    if (isMobile) return undefined;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMobile]);

  return (
    <>
      {/* <ModalAccessMenu
        openModalAccessMenu={openModalAccessMenu}
        setOpenModalAccessMenu={setOpenModalAccessMenu}
      /> */}
      <div
        className={`${isMobile ? `${!smallSide && 'fixed w-full'}` : `grid ${smallSide ? 'grid-cols-[auto,1fr]' : 'grid-cols-12'}`} min-h-0 h-screen bg-[#FCFCFD]`}
      >
        {/* Sidebar */}
        <Sidebar
          smallSide={smallSide}
          setSmallSide={setSmallSide}
          // setOpenModalAccessMenu={setOpenModalAccessMenu}
        />

        {/* Main Content */}
        <div
          className={`flex flex-col min-h-0 overflow-hidden ${isMobile ? `pt-` : `h-screen ${smallSide ? 'pl-' : 'col-span-10 '}`}`}
          // md:pl-4
        >
          {/* Page Content */}
          <Suspense fallback={<Loading />}>
            {/* <Suspense fallback={`Loading.....`}> */}
            <Outlet />
          </Suspense>
        </div>
      </div>
    </>
  );
};

export default DashboardTemplate;
